import { ComponentProps } from "react";
import { useTranslation } from "react-i18next";
import ServiceCard from "./ServiceCard";
import { useNoBookableStation } from "../../bookLocation/common/components/LocationSelectionStep/useNoBookableStation";
import { LocationListService } from "../../bookLocation/common/components/LocationSelectionStep/UseCaseLocationSelectionStep";

type Props = Omit<ComponentProps<typeof ServiceCard>, "statusBadge"> & {
  /** The `services` filter the tile's booking flow loads its stations with. */
  locationService: LocationListService;
};

/**
 * A home tile whose flow starts by picking a station. When the tenant has no
 * bookable station for it (e.g. every station closed for the winter) the tile
 * says "Aktuell geschlossen" up front, so the notice in the flow's location
 * step is not a surprise. The tile stays clickable and leads to that notice.
 *
 * Shares the cache entry with the flow's own location query
 * (`UseCaseLocationSelectionStep`), so opening the flow costs no second
 * request. Loading and failure show no badge: only a successful, empty answer
 * means "closed".
 */
const LocationGatedServiceCard = ({ locationService, ...cardProps }: Readonly<Props>) => {
  const { t } = useTranslation();
  const closed = useNoBookableStation(locationService);

  return (
    <ServiceCard
      {...cardProps}
      statusBadge={closed ? t("home.service_closed_badge") : undefined}
    />
  );
};

export default LocationGatedServiceCard;
